import { faXmark as CancelIcon } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { useAtom } from 'jotai';
import { sortBy } from 'lodash';
import { useMemo } from 'react';

import DualListSelect from '@/components/DualListSelect';
import { EXPORT_COLUMNS_CLOUD_SOURCES } from '@/constants/exportcolumns';
import formatCloudSourcesForExport from '@/features/CloudSourceExportDialog/CloudSourceExportDialog.utils';

import {
  cloudSourcesExportAtom,
  exportedCloudSourcesColumnSelectionAtom
} from '../CloudSourcesTable/CloudSourcesTable.store';
import useStyles from './CloudSourceExportDialog.styles';

const CloudSourceExportDialog = ({
  handleClose,
  open
}: {
  handleClose: () => void;
  open: boolean;
}) => {
  const [exportData] = useAtom(cloudSourcesExportAtom);
  const [selectedColumns, setSelectedColumns] = useAtom(
    exportedCloudSourcesColumnSelectionAtom
  );
  const { classes } = useStyles();

  const handelCancel = () => {
    handleClose();
  };

  const handleExport = () => {
    formatCloudSourcesForExport(exportData, selectedColumns);
    handleClose();
  };

  const options = useMemo(() => {
    return sortBy(EXPORT_COLUMNS_CLOUD_SOURCES, 'label');
  }, []);

  return (
    <Dialog fullWidth open={open} maxWidth="md">
      <DialogTitle>Cloud Source Export Column Selection</DialogTitle>
      <IconButton
        className={classes.cloudSourceExportDialogIconButtonCancel}
        onClick={handelCancel}
      >
        <FontAwesomeIcon size="xs" icon={CancelIcon} />
      </IconButton>
      <DialogContent className={classes.cloudSourceExportDialogDialogContent}>
        <DualListSelect
          labelAvailable="Available Columns"
          labelSelected="Selected Columns"
          options={options}
          selected={selectedColumns}
          onChange={setSelectedColumns}
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handelCancel}>
          Cancel
        </Button>
        <Button
          disabled={selectedColumns.length === 0}
          type="submit"
          variant="contained"
          onClick={handleExport}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloudSourceExportDialog;
